import { render, staticRenderFns } from "./light.vue?vue&type=template&id=b2163ba4&scoped=true"
import script from "./light.vue?vue&type=script&lang=ts"
export * from "./light.vue?vue&type=script&lang=ts"
import style0 from "./light.vue?vue&type=style&index=0&id=b2163ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2163ba4",
  null
  
)

export default component.exports